import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  ActionSteps = 'ActionSteps',
}

export const queryKeys = {
  actionSteps: (clientId: number, fpId: string) => [
    QueryFeature.ActionStepsReport,
    QueryKey.ActionSteps,
    clientId,
    fpId,
  ],
};
